/* eslint-disable import/prefer-default-export */
import api from '../_api';

export const trackingService = {
    vue_router_tracks(student, fromRouteName, fromParams, toRouteName, toParams, timestamp) {
        const payload = {
            student,
            from_route_rame: fromRouteName,
            from_params: fromParams,
            to_route_name: toRouteName,
            to_params: toParams,
            timestamp,
        };
        return api.post('/tracking/vue-router-tracks/', payload);
    },
    new_register_tracks(visitorUuid, isRegistered) {
        const payload = {
            is_registered: isRegistered,
        };
        return api.patch(`/tracking/new_register/${visitorUuid}`, payload);
    },
    new_visit_tracks(visitorUuid) {
        const payload = {
            visitor_uuid: visitorUuid,
        };
        return api.post('/tracking/new_visit', payload);
    },
};
